import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {EloquentManagerService} from "../../../shared/eloquent/providers/eloquent-manager.provider";
import {Project} from "../../../shared/eloquent/models/project.model";
import {City} from "../../../shared/eloquent/models/city.model";
import {LayoutService} from "../../../shared/services/layout/layout.service";
import {LanguageService} from "../../../shared/services/language/language.service";
import {Subscription} from "rxjs/Subscription";

declare const $: any;

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit, AfterViewInit, OnDestroy {


    public projectlist: Array<Project> = [];
    public filteredProjectList: Array<Project> = [];
    public cityList: Array<City> = [];
    public isLocationDropdownOpen = false;
    public isApplicationTypeDropdownOpen = false;
    public selectedCity = null;
    public selectedApplicationType = null;
    public isInitial = true;
    public isField = false;


    private languageSubscripton: Subscription;
    public currentLanguage = 'en';

    constructor(private eloquentManager: EloquentManagerService,
                private layoutService: LayoutService,
                private languageService: LanguageService) {

        this.layoutService.setTitle('Projects & References');


        this.eloquentManager.list(Project).subscribe((response) => {
            if (response) {
                this.projectlist = response;
                this.filteredProjectList = this.projectlist;
                this.filterByIsField(false);
                this.isInitial = false;
            }
        });

        this.eloquentManager.list(City).subscribe((response) => {
            if (response) {
                this.cityList = response;

            }
        });
    }

    ngOnInit() {
        this.subscribeLanguageEvents();

    }


    ngAfterViewInit(): void {

    }


    ngOnDestroy(): void {
        this.unsubscribeLanguageEvents();

    }

    private subscribeLanguageEvents() {
        this.languageSubscripton = this.languageService.language.subscribe((val) => {
            this.currentLanguage = val;
        });
    }

    private unsubscribeLanguageEvents() {
        this.languageSubscripton.unsubscribe();
    }

    filterByLocation = (value) => {
        this.isLocationDropdownOpen = false;
        console.log(value);
        if (!value) {
            this.selectedCity = null;
            this.filteredProjectList = this.projectlist;
            if (this.selectedApplicationType) {
                this.filterByApplicationType(this.selectedApplicationType);
                return;
            }
            return;
        }

        if (this.selectedApplicationType) {
            this.filteredProjectList = this.projectlist.filter(project => project.application_type == this.selectedApplicationType.value);
        }
        this.filteredProjectList = this.filteredProjectList.filter(project => project.city.id == value.id);
    }

    filterByApplicationType = (value) => {
        this.isApplicationTypeDropdownOpen = false;
        if (!value) {
            this.selectedApplicationType = null;
            this.filteredProjectList = this.projectlist;
            if (this.selectedCity) {
                this.filterByLocation(this.selectedCity);
            }

            return;
        }

        if (this.selectedCity) {
            this.filteredProjectList = this.projectlist.filter(project => project.city.id == this.selectedCity.id);
        }

        this.filteredProjectList = this.filteredProjectList.filter(project => project.application_type == value.value);
    }

    filterByIsField = (isField) => {
        this.isField = isField;

        if (this.selectedCity || this.selectedApplicationType) {

            if (this.selectedCity) {
                this.filterByLocation(this.selectedCity);
            }

            if (this.selectedApplicationType) {
                this.filterByApplicationType(this.selectedApplicationType);
            }
        } else {
            this.filteredProjectList = this.projectlist;
        }


        this.filteredProjectList = this.filteredProjectList.filter(project => project.is_field == isField);
    }
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/projects/projects.component.ts